import { render } from "./protocalInfo.vue?vue&type=template&id=1f6c663c&scoped=true"
import script from "./protocalInfo.vue?vue&type=script&lang=js"
export * from "./protocalInfo.vue?vue&type=script&lang=js"

import "./protocalInfo.vue?vue&type=style&index=0&id=1f6c663c&lang=scss&scoped=true"

import exportComponent from "D:\\XGprogect\\海尔会员\\haierhuiyuan-phone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6c663c"]])

export default __exports__